
import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // search
    const search = data.search ? '&s=' + data.search + '&s_field=title' : ''
    // pagination
    const page = data.page ? data.page : 1
    // status
    const fieldQuery = data.field_query ? '&field_query=' + JSON.stringify(data.field_query) : ''
    const tagID = data.tag_id ? data.tag_id : ''
    return axios.get(process.env.API_ENDPOINT + '/document?tag_id=' + tagID + '&token=' + VueCookies.get('token') + '&page=' + page + search + limit + fieldQuery)
  },
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/document?token=' + VueCookies.get('token'), data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/document/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/document/' + id + '?token=' + VueCookies.get('token'), data)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/document/' + id + '?token=' + VueCookies.get('token'))
  }
}



// WEBPACK FOOTER //
// ./src/store/api/documents.js